import {Component} from '@angular/core';

@Component({
    selector: '[support]',
    templateUrl: './SupportComponent.html',
    styleUrls: ['./SupportComponent.scss'],
    standalone: false
})

export class SupportComponent {
}
